import type React from 'react';

import { Translate, TranslateHtml } from '@change-corgi/core/react/i18n';
import { ButtonLink, Link } from '@change-corgi/design-system-legacy/components/actions';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { url },
		actions: { trackClick },
	} = usePageBody();

	return (
		<>
			<Text as="div" mb={40}>
				<TranslateHtml
					value="fe.pages.redirect.description"
					replacements={{
						url: (
							<Link to={url} onClick={() => trackClick('continue')} data-testid="continue-link" data-qa="continue-link">
								{url}
							</Link>
						),
					}}
				/>
			</Text>
			<Box>
				<ButtonLink
					to={url}
					variant="primary"
					sx={{ width: ['100%', 'auto'] }}
					mr={16}
					mb={[8, 0]}
					onClick={() => trackClick('continue')}
					data-testid="continue-button"
					data-qa="continue-button"
				>
					<Translate value="fe.pages.redirect.buttons.continue" />
				</ButtonLink>
				<ButtonLink
					to="/"
					variant="secondary"
					sx={{ width: ['100%', 'auto'] }}
					onClick={() => trackClick('back')}
					data-testid="back-button"
					data-qa="back-button"
				>
					<Translate value="fe.pages.redirect.buttons.go_to_change" />
				</ButtonLink>
			</Box>
		</>
	);
};
